export const handleInputPlaceholder = ({ userRole, enabled }) => {
  if (enabled) {
    return "conversation.new_message.placeholder";
  } else if (userRole === "seeker") {
    return "conversation.new_message_disabled.placeholder.seeker";
  }
  return "conversation.new_message_disabled.placeholder";
};
